declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

const GA_MEASUREMENT_ID = 'G-B6Q35178C7';
const CONSENT_KEY = 'split_analytics_consent';

export function hasConsent(): boolean {
  return localStorage.getItem(CONSENT_KEY) === 'granted';
}

export function setConsent(granted: boolean): void {
  localStorage.setItem(CONSENT_KEY, granted ? 'granted' : 'denied');

  if (granted) {
    initGA();
  }
}

export function initGA(): void {
  if (!hasConsent()) return;

  // Avoid double init
  if (typeof window.gtag !== 'undefined') return;

  // Load GA script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer.push(args);
  };

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    anonymize_ip: true,
    cookie_flags: 'SameSite=None;Secure',
  });
}

export function trackEvent(action: string, category: string, label?: string): void {
  if (!hasConsent() || !window.gtag) return;

  window.gtag('event', action, {
    event_category: category,
    event_label: label,
  });
}

export function trackPageView(path: string): void {
  if (!hasConsent() || !window.gtag) return;

  window.gtag('event', 'page_view', {
    page_path: path,
  });
}
